import { render, staticRenderFns } from "./FiscalSettings.vue?vue&type=template&id=2c9e77fe&scoped=true"
import script from "./FiscalSettings.vue?vue&type=script&lang=js"
export * from "./FiscalSettings.vue?vue&type=script&lang=js"
import style0 from "./FiscalSettings.vue?vue&type=style&index=0&id=2c9e77fe&prod&scoped=true&lang=css"
import style1 from "./FiscalSettings.vue?vue&type=style&index=1&id=2c9e77fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9e77fe",
  null
  
)

export default component.exports